<div class="security-message"><LockIcon class="icon-lock"></LockIcon><small>{{ $t('securityMessage') }}</small></div>